import { VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@shared/utils/helpers';
import { PropsWithClassName } from '@shared/utils/types';

import { alertVariants } from './Alert.cva';

type Props = {
  title?: React.ReactNode;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof alertVariants>;

export const Alert = ({ title, className, variant, children, ...props }: Props) => (
  <div role="alert" className={cn(alertVariants({ variant }), className)} {...props}>
    {title && <div className="mb-1 font-medium leading-none tracking-tight">{title}</div>}
    <div className="text-sm [&_p]:leading-relaxed">{children}</div>
  </div>
);
